import script from "./PlaceAnOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceAnOrder.vue?vue&type=script&setup=true&lang=js"

import "./PlaceAnOrder.vue?vue&type=style&index=0&id=4e21f344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e21f344"]])

export default __exports__